/* eslint-disable react-hooks/exhaustive-deps */
import { motion, AnimatePresence } from 'framer-motion';
import React, { lazy, memo, Suspense, useEffect, useContext, useRef } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import allRoutes from '../routes/RouteFile'; // Shoorah Super Admin
import b2bRoutes from './adminRoutes'; // B2B Super Admin
import partnerRoutes from './partnerRoutes';
import expertRoutes from './expertRoutes';

import Loader from '../component/common/Loader';
import PropTypes from 'prop-types';
// import Sidebar from "../layout/Sidebar";
import NewSidebar from '../layout/newSidebar';
import useWindowDimensions, {
  cleanLocalStorage,
  getDeviceToken,
  getLocalStorageItem
} from '../utils/helper';
import { SidebarContext } from '../context/SidebarContext';
import RightSidebar from '../layout/RightSidebar';

import { useState } from 'react';
import { Api } from '../api';
import ExpertSidebar from '../layout/expertSidebar';

const Login = lazy(() => import('../container/Login'));

const LoadSideBar = () => {
  const location = useLocation();
  const [slide, setSlide] = useState(false);
  const ref = useRef();

  // Public routes that should not show sidebar
  const publicRoutes = ['/login', '/reset-password', '/forgot-password', '/setup-password', '/millwall', '/volleyballEngland', '/norwich'];
  const currentPath = location?.pathname?.replace(/\/$/, ''); // Remove trailing slash
  const isPublicRoute = publicRoutes.includes(currentPath);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!ref?.current?.contains(event.target)) {
        setSlide(false);
      }
    };
    // document.addEventListener('mousedown', handleClickOutside);
  }, [ref]);

  return (
    <>
      {!isPublicRoute && (
        <div className="relative h-full">
          <button
            style={{ transition: 'transform 0.3s ease-in-out' }}
            className={`w-[26px] md:hidden h-[26px] rounded-full border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder flex items-center justify-center absolute top-[75px] z-[999] bg-white dark:bg-shoorah-darkBgTabColor dark:text-white ${slide ? 'translate-x-[286px]' : 'translate-x-0'
              }`}
            onClick={() => {
              setSlide(!slide);
            }}
          >
            {slide ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M1.19629 6.99902H12.8038"
                  stroke="black"
                  strokeWidth="0.9996"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.99083 3.20508C3.47301 3.964 1.9552 5.48181 1.19629 6.99957C1.9552 8.51744 3.47301 10.0352 4.99083 10.7942"
                  stroke="black"
                  strokeWidth="0.9996"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12.8037 6.99902H1.19621"
                  stroke="black"
                  strokeWidth="0.9996"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.00917 3.20508C10.527 3.964 12.0448 5.48181 12.8037 6.99957C12.0448 8.51744 10.527 10.0352 9.00917 10.7942"
                  stroke="black"
                  strokeWidth="0.9996"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
          {/* <Sidebar slide={slide} /> */}
          <NewSidebar slide={slide} />
        </div>
      )}
    </>
  );
};

const RoutesList = memo(() => {
  const { width } = useWindowDimensions();
  const { setShow } = useContext(SidebarContext);

  useEffect(() => {
    if (width < 1024) {
      setShow(false);
    }
  }, [width]);

  return (
    <Router>
      <ConditionalRoute />
    </Router>
  );
});

export const ConditionalRoute = () => {
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const userType = userData?.userType;
  // Roles whose account menu lives in the Topbar rather than a right sidebar.
  const usesAvatarMenu = [0, 1, 3, 4].includes(userType);
  const [RoutesFile, setRoutesFile] = useState([]);

  // Public routes that should not show sidebar or require authentication
  const publicRoutes = ['/login', '/reset-password', '/forgot-password', '/setup-password', '/millwall', '/volleyballEngland', '/norwich'];
  const currentPath = location?.pathname?.replace(/\/$/, ''); // Remove trailing slash
  const isPublicRoute = publicRoutes.includes(currentPath);


  useEffect(() => {
    if (window.location.pathname !== '/login')
      if (userData?.userType === 0 || userData?.userType === 1) {
        setRoutesFile(allRoutes); // Shoorah Super Admin
      } else if (userData?.userType === 3 || userData?.userType === 4) {
        setRoutesFile(b2bRoutes); // B2B Super Admin
      } else if (userData?.userType === 5) {
        setRoutesFile(partnerRoutes);
      } else if (userData?.userType === 6) {
        setRoutesFile(expertRoutes);
      } else {
        setRoutesFile(allRoutes);
      }

    if (userData?.userType === 2) {
      cleanLocalStorage();
      window.location.href = '/login';
    }
  }, [window.location.pathname]);

  const logoutUser = async () => {
    await Api.logoutUser().then((res) => {
      cleanLocalStorage();
      window.location.href = '/login';
    });
  };

  const windowPath = window.location?.pathname?.replace(/\/$/, ''); // Remove trailing slash
  if (!publicRoutes.includes(windowPath)) {
    if (!getLocalStorageItem('token')) {
      if (getDeviceToken()) {
        logoutUser();
      } else {
        cleanLocalStorage();
        window.location.href = '/login';
      }
      return <></>;
    }
  }
  return (
    <>
      {!isPublicRoute ? (
        <>
          <div className="h-screen flex overflow-hidden bg-shoorah-normanGray dark:bg-shoorah-darkBgColor">
            <motion.div
              initial={{
                x: -100,
                opacity: 0
              }}
              animate={{
                x: 0,
                opacity: 1,
                transition: {
                  duration: 0.5
                }
              }}
              className="md:col-span-1 pointer-events-none h-[90%] md:h-screen md:relative fixed z-[42]"
            >
              <div
                className={`h-full ${isDrawerOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
                  } transition-transform relative pointer-events-auto`}
              >
                <LoadSideBar />

                {isDrawerOpen && (
                  <div
                    onClick={() => {
                      setIsDrawerOpen(false);
                    }}
                    className="absolute w-8 h-8 p-1 bg-white shadow-md dark:bg-shoorah-darkBgTabColor dark:text-white rounded-full -right-10 top-6"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-full h-full"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                  </div>
                )}
              </div>
            </motion.div>
            <AnimatePresence exitBeforeEnter={true}>
              <div
                key={location?.pathname}
                className={`hide-scrollbar h-full max_container md:h-screen relative overflow-y-auto px-4 pt-[105px] pb-5 md:px-5 md:py-5 lg:px-6 ${
                  // 500px = 250px left sidebar + 250px right sidebar. B2B admins
                  // and Shoorah staff no longer render the right sidebar, so
                  // they reclaim its 250px.
                  (location?.pathname.includes('/dashboard') ||
                    location?.pathname.includes('/partner-dashboard')) &&
                  !usesAvatarMenu
                    ? 'lg:w-[calc(100%-500px)] w-full'
                    : 'w-full'
                }`}
              >
                {/* <Topbar /> */}
                <motion.div
                // initial={{
                //   y: 100,
                //   opacity: 0
                // }}
                // animate={{
                //   y: 0,
                //   opacity: 1,
                //   transition: {
                //     duration: 0.5
                //   }
                // }}
                >
                  <Suspense fallback={<Loader />}>
                    <Routes>
                      {RoutesFile.map((itm, key) => (
                        <Route key={key} path={itm.path} element={<itm.component />}>
                          {itm.children &&
                            itm.children.map((child, childKey) => (
                              <Route
                                key={childKey}
                                path={child.path}
                                element={<child.component />}
                              />
                            ))}
                        </Route>
                      ))}
                      <Route path="/login" element={<Login />} />
                      <Route path="/" element={<Navigate to="/login" />} />
                    </Routes>
                  </Suspense>
                </motion.div>
              </div>
            </AnimatePresence>

            {/* B2B admins (userType 3/4) and Shoorah staff (0/1) no longer get
                the right sidebar — its profile card moved into the Topbar
                avatar menu, freeing the column for dashboard content. Partners
                and experts are unchanged. */}
            {!usesAvatarMenu &&
              (location.pathname.includes('/dashboard') ||
                location.pathname.includes('/kids-dashboard') ||
                location.pathname.includes('/partner-dashboard')) && (
                <motion.div
                  initial={{
                    x: 100,
                    opacity: 0
                  }}
                  animate={{
                    x: 0,
                    opacity: 1,
                    transition: {
                      duration: 0.5
                    }
                  }}
                  className="col-span-1 lg:block hidden absolute lg:relative right-4 top-5 lg:right-auto lg:top-auto lg:h-screen w-[250px]"
                >
                  <RightSidebar />
                </motion.div>
              )}

            {userType === 6 && (
              <motion.div
                initial={{
                  x: 100,
                  opacity: 0
                }}
                animate={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    duration: 0.5
                  }
                }}
                className="col-span-1 lg:block absolute lg:relative right-4 top-5 lg:right-auto lg:top-auto lg:h-screen w-[250px]"
              >
                <ExpertSidebar />
              </motion.div>
            )}
          </div>
        </>
      ) : (
        <>
          <LoadSideBar />
          <Suspense fallback={<Loader />}>
            <Routes>
              {RoutesFile.map((itm, key) => (
                <Route key={key} path={itm.path} element={<itm.component />}>
                  {itm.children &&
                    itm.children.map((child, childKey) => (
                      <Route key={childKey} path={child.path} element={<child.component />} />
                    ))}
                </Route>
              ))}
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/login" />} />
            </Routes>
          </Suspense>{' '}
        </>
      )}
    </>
  );
};

RoutesList.propTypes = {
  isShow: PropTypes.any,
  setShow: PropTypes.any
};

export default RoutesList;
